import SettingsCard from "../SettingsCard"
import { TenantLink } from "../../../domain/proposals/settings/proposalSettings"
import { useEffect, useState } from "react"
import VSpace from "../../common/VSpace"
import { Button, Input, Row, Skeleton } from "antd"
import { Col } from "antd"
import { faBars, faLink, faTrash } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { addLink, areLinksChanged, deleteLink, updateLinkDisplayText, updateLinkUrl } from "./proposalLinksModel"
import { useProposalLinksQuery, useUpdateLinksMutation } from "../../../domain/proposals/settings/proposalSettingsQueries"

const ProposalLinks = () => {
  const proposalLinksQuery = useProposalLinksQuery()
  const updateLinksMutation = useUpdateLinksMutation()
  const [links, setLinks] = useState<TenantLink[]>([])
  const isChanged = areLinksChanged(proposalLinksQuery.data ?? [], links)

  useEffect(() => {
    if (proposalLinksQuery.data) {
      setLinks(proposalLinksQuery.data)
    }
  }, [proposalLinksQuery.data])

  if (proposalLinksQuery.isLoading) {
    return <SettingsCard
      title="Proposal Links"
      description="Add links to external content you want to include in your proposals, like portfolio projects or reference materials."
      isUpdating={false}
      updateDisabled={true}
      onUpdate={() => {}}
    >
      <Skeleton active />
    </SettingsCard>
  }

  return <SettingsCard
    title="Proposal Links"
    description="Add links to external content you want to include in your proposals, like portfolio projects or reference materials."
    onUpdate={() => {
      updateLinksMutation.mutate(links)
    }}
    isUpdating={updateLinksMutation.isLoading}
    updateDisabled={!isChanged}
  >
    <VSpace>
      {
        links.map((link) => (
          <Row key={link.id} style={{ border: '1px solid #ddd', padding: 10, borderRadius: 5 }}>
            <Col span={8} style={{paddingRight: '4px'}}>
              <Input
                placeholder="Name"
                value={link.displayText}
                prefix={<FontAwesomeIcon icon={faBars} color="#aaa" />}
                onChange={e => setLinks(updateLinkDisplayText(links, link.id, e.target.value))}
                status={link.displayText === '' ? 'error' : undefined}
              />
            </Col>
            <Col span={8} style={{paddingLeft: '4px'}}>
              <Input
                placeholder="Link URL"
                value={link.url}
                prefix={<FontAwesomeIcon icon={faLink} color="#aaa" />}
                onChange={e => setLinks(updateLinkUrl(links, link.id, e.target.value))}
                status={link.url === '' ? 'error' : undefined}
              />
            </Col>
            <Col span={8} style={{textAlign: 'right'}}>
              <Button
                ghost
                icon={<FontAwesomeIcon icon={faTrash} color="#aaa" />}
                onClick={() => setLinks(deleteLink(links, link.id))}
              />
            </Col>
          </Row>
        ))
      }
      <Row>
        <Col span={24} style={{textAlign: 'right'}}>
          <Button onClick={() => setLinks(addLink(links))} >+ Add Link</Button>
        </Col>
      </Row>
    </VSpace>
  </SettingsCard>
}

export default ProposalLinks
